'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

export default function AnuroopWiwahaLogin() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      {/* Transparent Header */}
      <Header variant="transparent" />

      <HomeHeroSection
        title="अनुरूप मराठी वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="anuroop_wiwaha_login"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {[
                {
                  question: "Can I make free registration on Marathi Vadhu Var Suchak?",
                  answer: "Yes! you can make free registration through Marathi Vadhu Var Suchak app. You can use MarathiVadhuVarSuchak.com Marathi matrimony site or Mobile app for free registration."
                },
                {
                  question: "How to make online registration Marathi Vadhu Var Suchak using a website or app?",
                  answer: "Visit official MarathiVadhuVarSuchak.com Marathi matrimony site or download Android or iOS app for free registration."
                },
                {
                  question: "Where is Marathi Vadhu Var Suchak located?",
                  answer: "'Marathi Vadhu Var Suchak' is Mumbai based Marathi Vadhu Var Suchak Kendra. But, we provide service for the whole Maharashtra and all Marathi communities."
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">
                      {faq.question}
                    </h3>
                    <svg
                      className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                        openFAQ === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div
                    className={`px-6 transition-all duration-300 ease-in-out ${
                      openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                    }`}
                  >
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Anurup Vivah community for Marathi Vadhu Var Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">
            Why Parents Search for Anuroop Vadhu Var in the Marathi Community?
            </h2>
            <p className="text-gray-700 leading-relaxed" style={{ fontSize: '1.11rem' }}>
            In the Marathi community, parents approach the search for a life partner with deep responsibility, love, and cultural wisdom - always seeking an Anuroop Vadhu Var, meaning a truly compatible and well-suited match for their son or daughter. Anuroop goes beyond physical appearance - it encompasses matching of family values, education, social standing, nature, and horoscope, ensuring a balanced and harmonious married life ahead. Marathi parents believe that when two individuals are Anuroop, the marriage brings not only personal happiness but also strengthens the bond between both families for generations. Factors like Gotra, Kul, Nakshatra, financial stability, and character are carefully considered to find a partner who aligns with their child's overall personality and life goals. This thoughtful and values-driven approach reflects the Marathi community's deep respect for the institution of marriage as a lifelong and sacred commitment. At MarathiVadhuVarSuchak.com, we make this meaningful search easier by offering thousands of verified Anuroop Marathi Vadhu Var profiles - because your child deserves nothing less than the perfect match.
            </p>
          </div>
        </div>
      </section>

    </div>
  );
}

